module.exports = __webpack_public_path__ + "static/media/Dual_6530.56b6a57d.jpg";